var _g, _defs;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgIconsFacebookFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3836_456)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 11.5642C0 17.2816 4.15246 22.0359 9.58333 23V14.6941H6.70833V11.5H9.58333V8.94413C9.58333 6.06913 11.4358 4.47254 14.0559 4.47254C14.8858 4.47254 15.7809 4.6 16.6108 4.72746V7.66667H15.1417C13.7358 7.66667 13.4167 8.36912 13.4167 9.26421V11.5H16.4833L15.9725 14.6941H13.4167V23C18.8475 22.0359 23 17.2826 23 11.5642C23 5.20375 17.825 0 11.5 0C5.175 0 0 5.20375 0 11.5642Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3836_456"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsFacebookFill);
export default __webpack_public_path__ + "static/media/icons-facebook-fill.ead380c89f011834ed092adf0023e6fe.svg";
export { ForwardRef as ReactComponent };